import { Injectable } from '@angular/core';
import { LanguageService } from '../shared/services/language.service';
import { LastTenantPreferenceService } from '../shared/services/preferences/last-tenant-preference.service';
import { TableColumnsPreferencesService } from '../shared/store/table-columns-store/table-columns-preferences.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
  constructor(
    private languageService: LanguageService,
    // NBO-2516: injected for its construction side effect — it hydrates the column layouts from the
    // signed-in user's preferences (and starts PreferencesService) before the first route renders.
    _tableColumnsPreferences: TableColumnsPreferencesService,
    // NBO-2517: likewise — it writes the active tenant to the account from the first login on.
    // (The other kinds are built by their first user; nothing of theirs has to run at boot.)
    _lastTenantPreference: LastTenantPreferenceService
  ) {}

  initializeApp(): Promise<void> {
    try {
      this.languageService.init();
    } catch (error) {
      console.error('Error during app initialization:', error);
    }
    return Promise.resolve();
  }
}
